// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"password-dialog_shadow__2QctA","submitButton":"password-dialog_submitButton__3JlvR"};